import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'

import getters from './getters'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      reducer: state => ({
        auth: state.auth
      })
    })
  ],
  getters
})

export default store
